import { render, staticRenderFns } from "./RoyaltyTransactionTable.vue?vue&type=template&id=d2d4812a&scoped=true&"
import script from "./RoyaltyTransactionTable.vue?vue&type=script&lang=js&"
export * from "./RoyaltyTransactionTable.vue?vue&type=script&lang=js&"
import style0 from "./RoyaltyTransactionTable.vue?vue&type=style&index=0&id=d2d4812a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d4812a",
  null
  
)

export default component.exports